const CRAPI_URL = 'https://stage-api.crunchyroll.com'
const CRAPI_AUTH_ID = process.env.GATSBY_STAGE_CRAPI_AUTH_ID || ''
const CR_ETP_URL = 'https://stage.crunchyroll.com'
const COOKIE_DOMAIN = '.crunchyroll.com'
const NEWSAPI_URL = 'https://cr-news-api-service.stg.crunchyrollsvc.com/v1/'
const ENV = 'staging'

export default {
  env: ENV,
  domain: CR_ETP_URL,
  crApiUrl: CRAPI_URL,
  crApiAuthId: CRAPI_AUTH_ID,
  crEtpUrl: CR_ETP_URL,
  cookieDomain: COOKIE_DOMAIN,
  newsApiUrl: NEWSAPI_URL,
}
